var dom, svg;

({dom, svg} = require('../odo/odojs/'));

module.exports = function(d) {
  return dom('.page--normal', [
    dom('nav',
    dom('a.nav--logo',
    {
      attributes: {
        href: '/'
      }
    },
    svg('svg',
    {},
    svg('use',
    {
      'xlink:href': '/assets.svg#logo-horizontal'
    })))),
    dom('hr'),
    dom('.page--content',
    d),
    dom('hr.secondary'),
    dom('footer',
    [
      dom('ul',
      [
        dom('li',
        dom('a',
        {
          attributes: {
            href: '/contact'
          }
        },
        'Contact Us'))
      ])
    ])
  ]);
};
